// imageData.js
// import side_slider_1 from '../../assets/images/side_slider_1.jpg';
// import side_slider_2 from '../../assets/images/basketball_banner_7.jpg';
// import football_side_slider_1 from '../../assets/images/football_side_slider_1.jpg';
//  import football_side_slider_2 from '../../assets/images/football_side_slider_2.jpg';

 
// import creighton_2 from '../../assets/images/creighton_2.webp'
// import creighton_4 from '../../assets/images/creighton_4.jpg'
import fb_6 from '../../assets/images/maryland13.png';
import fb_8 from '../../assets/images/maryland11.png';


export const sliderImages = [
  {
    id: 1,
    url: fb_6
  },
  {
    id: 2,
    url: fb_8
  },
];
